/**
 * Copyright (c) Microsoft. All rights reserved.
 */
import { Icon } from '@fluentui/react/lib/Icon';
import { Persona, PersonaSize } from '@fluentui/react/lib/Persona';
import { Stack } from '@fluentui/react/lib/Stack';
import { getTheme } from '@fluentui/react/lib/Styling';
import { Text } from '@fluentui/react/lib/Text';
import { classNamesFunction, getId } from '@fluentui/react/lib/Utilities';
import * as React from 'react';
import { Labeler } from '../../../../react-text-annotator/lib/esm';
import { formatSentenceAnnotations, generateEntityColorFromString, getReadableDuration } from './utils';
const { palette } = getTheme();
const sentimentTextStyles = classNamesFunction()({
    root: { textTransform: 'capitalize', color: palette.neutralSecondary }
});
const sentimentContainerStyles = classNamesFunction()({
    root: { minWidth: 85, padding: '18px 0 10px 0' }
});
const getSentimentIconName = sentiment => {
    switch (sentiment) {
        case 'negative':
            return 'ArrowTallDownRight';
        case 'neutral':
            return 'CalculatorSubtract';
        case 'positive':
            return 'ArrowTallUpRight';
        default:
    }
};
const getSentimentIconStyles = sentiment => {
    let color = '';
    switch (sentiment) {
        case 'negative':
            color = '#A80000';
            break;
        case 'neutral':
            color = palette.neutralTertiary;
            break;
        case 'positive':
            color = '#018A39';
            break;
        default:
    }
    return classNamesFunction()({
        root: { color, fontWeight: 600 }
    });
};
const getSpeakerPersonaStyles = speakerName =>
    classNamesFunction()({
        initials: {
            background: `${generateEntityColorFromString(speakerName)} !important`
        }
    });
export const AnalyzedSentence = props => {
    const { sentence, hidePii, showSentiment = true } = props;
    return React.createElement(
        Stack,
        { horizontal: true, tokens: { padding: '10px 10px 0 10px' } },
        showSentiment &&
            React.createElement(
                Stack,
                { horizontalAlign: 'center', tokens: { childrenGap: 3 }, styles: sentimentContainerStyles },
                React.createElement(Icon, {
                    styles: getSentimentIconStyles(sentence.sentiment),
                    iconName: getSentimentIconName(sentence.sentiment)
                }),
                React.createElement(Text, { variant: 'xSmall', styles: sentimentTextStyles }, sentence.sentiment)
            ),
        React.createElement(
            Stack,
            { horizontal: true },
            React.createElement(Persona, {
                hidePersonaDetails: true,
                size: PersonaSize.size28,
                styles: { root: { paddingTop: '20px' } },
                coinProps: {
                    styles: getSpeakerPersonaStyles(sentence.speakerTitle)
                }
            }),
            React.createElement(
                Stack,
                null,
                React.createElement(
                    Text,
                    { variant: 'small', styles: { root: { paddingLeft: 10 } } },
                    '[',
                    React.createElement(Text, { variant: 'small', styles: { root: { fontWeight: 600 } } }, sentence.speakerTitle),
                    '\u00A0',
                    getReadableDuration(sentence.duration),
                    ']'
                ),
                React.createElement(Labeler, {
                    key: getId(),
                    labelerConfigs: { isDisabled: true },
                    annotations: formatSentenceAnnotations(sentence),
                    text: hidePii ? sentence.redactedText : sentence.text
                })
            )
        )
    );
};
